import {Component, OnInit} from '@angular/core';

import {ConfigurationService} from '../configuration.service';
import {UserService} from '../user/user.service';

@Component({
  selector: 'aqx-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  configuration;
  title = 'API Store';
  isUserEntitledApiStore: boolean;

  constructor(
    private configurationService: ConfigurationService,
    private userService: UserService,
    ) {
  }

  ngOnInit() {
    this.userSubscribe();
    this.configuration = this.configurationService.getConfiguration();
  }

  userSubscribe(): void {
    this.userService.userObservable
      .subscribe(user => {
        this.isUserEntitledApiStore = this.userService.isUserEntitledApiStore();
      });
  }
}
